import React, { useState } from 'react';
import { Box } from '@mui/material';
import { GridStyledDOB } from './style';
import { TypographyStyled } from '../../shared/components/numberInput/numberCards/styles';
import { PlaceholderGrid } from '../../styles/globalStyles';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { setPatientInformation } from '../../store/slices/metaDataSlice';
import { months } from '../../shared/shared.constants';
import { years, getDaysInMonth } from '../../shared/utils/utilFunctions';
import { Dropdown } from '../../shared/components/dropdown';

export const DOBView = () => {
  const dispatch = useDispatch();
  const { patientInformation } = useAppSelector(metaDataSelector);
  const selectedMonth = patientInformation?.dob?.month || 1;
  const selectedYear = patientInformation?.dob?.year || 2025;
  const [days, setDays] = useState<number[]>(
    getDaysInMonth(selectedMonth, selectedYear)
  );

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const updatedDate = { ...patientInformation?.dob, [name as string]: value };

    // When month or year changes, update the available days
    if (name === 'month' || name === 'year') {
      const newDays = getDaysInMonth(updatedDate.month, updatedDate.year);
      setDays(newDays);

      // If selected day is no longer valid, update it
      if (updatedDate.day > newDays.length) {
        updatedDate.day = newDays.length; // Set to the last valid day
      }
    }
    dispatch(
      setPatientInformation({
        ...patientInformation,
        dob: updatedDate,
        age: updatedAge(updatedDate.month, updatedDate.year)
      })
    );
  };

  function updatedAge(birthMonth: number, birthYear: number) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    let ageYears = currentYear - birthYear;
    let ageMonths = currentMonth + 1 - birthMonth;
    if (ageMonths < 0) {
      ageMonths += 12;
      ageYears -= 1;
    }
    return {
      years: birthYear > 0 ? ageYears : 0,
      months: birthMonth > 0 ? ageMonths : 0
    };
  }

  const getDayVal = () => {
    if (patientInformation?.dob?.day > days.length) {
      dispatch(
        setPatientInformation({
          ...patientInformation,
          dob: {
            ...patientInformation.dob,
            day: days.length
          }
        })
      );
      return days.length;
    }
    return patientInformation?.dob?.day;
  };

  return (
    <PlaceholderGrid container sx={{ width: '100%' }} margin={'1.25rem 0'}>
      <TypographyStyled
        variant="h5"
        sx={{
          fontSize: '0.875rem',
          lineHeight: '1.125rem',
          fontFamily: 'BGBold'
        }}
      >
        {'DATE OF BIRTH'}
      </TypographyStyled>
      <GridStyledDOB>
        <Box width={'26%'}>
          <Dropdown
            label={'Day'}
            data={days}
            value={getDayVal()}
            handleChange={handleChange}
          />
        </Box>
        <Box width={'44%'} sx={{ margin: '0 0.625rem' }}>
          <Dropdown
            label={'Month'}
            data={months}
            value={patientInformation?.dob?.month}
            handleChange={handleChange}
          />
        </Box>
        <Box width={'26%'}>
          <Dropdown
            label={'Year'}
            data={years()}
            value={patientInformation?.dob?.year}
            handleChange={handleChange}
          />
        </Box>
      </GridStyledDOB>
    </PlaceholderGrid>
  );
};
